// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5689) return "static/chunks/5689-3c7ef9521db0f236.js";
	if (chunkId === 5333) return "static/chunks/5333-bc847ed6f0dd26b9.js";
	if (chunkId === 7264) return "static/chunks/7264-ff273323e1865c69.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2996":"b7acaf7102ccc903","5571":"3f79042563921ec4","6610":"3ff5d171c6b709a8","7045":"6991153c1ee3907a","8391":"b032095a88f05b35","9964":"e1b29d89b8d60552"}[chunkId] + ".js";
};